import http from '@/http'

export function get() {
  return http.get('/config')
}